import React from 'react';
import PropTypes from 'prop-types';

import './index.sass';

import ProductImage from '../../Atoms/ProductImage';
import Arrow from '../../Atoms/Arrow';

const SWIPE_THRESHOLD = 50;

class ProductImageGallery extends React.Component {
	touchStartX = null;

	touchStartY = null;

	handlePrevious = (event) => {
		if (event) event.stopPropagation();
		const { activeIndex, images, onChangeIndex } = this.props;
		const nextIndex = activeIndex === 0 ? images.length - 1 : activeIndex - 1;
		onChangeIndex(nextIndex);
	};

	handleNext = (event) => {
		if (event) event.stopPropagation();
		const { activeIndex, images, onChangeIndex } = this.props;
		const nextIndex = activeIndex === images.length - 1 ? 0 : activeIndex + 1;
		onChangeIndex(nextIndex);
	};

	handleTouchStart = (event) => {
		const touch = event.touches[0];
		this.touchStartX = touch.clientX;
		this.touchStartY = touch.clientY;
	};

	handleTouchEnd = (event) => {
		if (this.touchStartX === null || this.touchStartY === null) return;

		const touch = event.changedTouches[0];
		const deltaX = touch.clientX - this.touchStartX;
		const deltaY = touch.clientY - this.touchStartY;

		this.touchStartX = null;
		this.touchStartY = null;

		if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) {
			return;
		}

		event.stopPropagation();

		if (deltaX > 0) {
			this.handlePrevious();
		} else {
			this.handleNext();
		}
	};

	render() {
		const {
			className,
			images,
			activeIndex,
			imageType,
			showNavigation,
		} = this.props;
		const activeImage = images[activeIndex] || images[0];

		if (!activeImage) return null;

		const hasMultipleImages = images.length > 1;
		const canNavigate = showNavigation && hasMultipleImages;

		return (
			<div
				className={`ProductImageGallery ${className}`}
				onTouchStart={canNavigate ? this.handleTouchStart : undefined}
				onTouchEnd={canNavigate ? this.handleTouchEnd : undefined}
			>
				<ProductImage
					className="ProductImageGallery__image"
					src={activeImage.url}
					alt={activeImage.alt}
					type={imageType}
				/>
				{canNavigate && (
					<>
						<div className="ProductImageGallery__arrow ProductImageGallery__arrow--left">
							<Arrow
								direction="left"
								size="small"
								onClick={this.handlePrevious}
							/>
						</div>
						<div className="ProductImageGallery__arrow ProductImageGallery__arrow--right">
							<Arrow
								direction="right"
								size="small"
								onClick={this.handleNext}
							/>
						</div>
						<div className="ProductImageGallery__dots">
							{images.map((image, index) => (
								<button
									key={image.id}
									type="button"
									className={`ProductImageGallery__dot ${index === activeIndex ? 'ProductImageGallery__dot--active' : ''}`}
									onClick={(event) => {
										event.stopPropagation();
										this.props.onChangeIndex(index);
									}}
									aria-label={`Image ${index + 1}`}
								/>
							))}
						</div>
					</>
				)}
			</div>
		);
	}
}

ProductImageGallery.propTypes = {
	className: PropTypes.string,
	images: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.string.isRequired,
		url: PropTypes.string.isRequired,
		alt: PropTypes.string,
	})).isRequired,
	activeIndex: PropTypes.number.isRequired,
	onChangeIndex: PropTypes.func.isRequired,
	imageType: PropTypes.oneOf(['thumb', 'large']),
	showNavigation: PropTypes.bool,
};

ProductImageGallery.defaultProps = {
	className: '',
	imageType: 'thumb',
	showNavigation: true,
};

export default ProductImageGallery;
